<script setup lang="ts">
import { LucideLoaderCircle } from 'lucide-vue-next'
import { FeatureExchangeRateSticky } from '~/components/feature/exchange-rate-sticky'
import { CurrencyIcon } from '~/components/ui/currency-icon'

const props = defineProps<{
  currency: string
  buyValue?: number | null
  sellValue?: number | null
}>()

const currencyList = useCurrencyStore().list
const currencyId = computed(
  () => currencyList.find((i) => i.code.toLowerCase() === props.currency.toLowerCase())?.id
)
</script>

<template>
  <article class="flex items-center md:gap-2">
    <CurrencyIcon :code="currency" size="lg" class="mr-0.5 hidden sm:mr-1 sm:block sm:size-7" />
    <NuxtImg
      v-if="currency !== 'cny'"
      :src="useAsset(`images/flags/${currency}.png`)"
      :alt="currency"
      width="16"
      height="12"
      class="mr-0.5 block sm:mr-1 sm:hidden"
    />
    <div class="flex items-center text-xs md:gap-0.5 xl:text-sm">
      <span class="hidden uppercase sm:inline">{{ currency }}</span>
      <div class="flex items-center gap-1.5 sm:gap-2">
        <FeatureExchangeRateSticky
          v-if="props.buyValue"
          :sell-value="props.sellValue || 0"
          :buy-value="props.buyValue || 0"
          :currency-id="currencyId || 0"
        />
        <LucideLoaderCircle v-else class="ml-3 size-4 animate-spin" />
      </div>
    </div>
  </article>
</template>
